import { none as n, stripNullishBlank as c } from "../fp/optional/utils.js";
import { preprocess as i } from "../node_modules/.pnpm/zod@4.3.6/node_modules/zod/v4/classic/schemas.js";
const p = (s, e) => {
  const r = e.safeParse(s);
  return r.success ? r.data : n();
}, l = (s) => i(c, s), u = (s, e) => {
  const r = Object.keys(e), t = Object.fromEntries(r.map((o) => [o, !0]));
  return s.omit(t).extend(e);
};
export {
  p as maybeParse,
  u as refineFields,
  l as stripNullishBlankPreprocess
};
//# sourceMappingURL=utils.js.map
